import { NamePath } from "antd/es/form/interface";
import * as React from "react";

import { dictEditsForTypes } from "../dictCompForTypes";
import { SelectComponent } from "./SelectComponent";

type PropsSelectEditComponent = {
  path: NamePath;
  value?: string;
  onChange?(value?: string): void;
};

export const SelectEditComponent: React.FC<PropsSelectEditComponent> = (
  props,
) => {
  const { path, value, onChange } = props;
  return (
    <SelectComponent
      path={path}
      dict={dictEditsForTypes}
      value={value}
      onChange={onChange}
    />
  );
};
